import React from 'react'
import { connect } from 'react-redux'
import { Skeleton } from '@material-ui/lab'
import { Box, Divider } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'
import { selectUserTeam } from '../../redux/selectors/userTeamSelectors'
import { selectOfficeAccounts } from '../../redux/selectors/accountSelectors'
import { teamAccountRoute } from '../../routes/routes'
import { formatUrl } from '../../util/formatUtils'
import { themeConWeb } from '../../util/modernThemeConweb'
import { selectLocationPreferred } from '../../redux/selectors/locationSelectors'
import { hasTeam } from '../teams/teamUtils'
import AccountWidget from './AccountWidget'
import HomeUnlockPreferredPricing from './HomeUnlockPreferredPricing'

const OfficeWidget = props => <AccountWidget title="Office" isManager {...props} />
const TeamWidget = props => <AccountWidget title="Team" isManager {...props} />

const useStyles = makeStyles(() => ({
  manageButton: {
    cursor: 'pointer',
    fontSize: `${themeConWeb.fontSizes.base}`,
    margin: '4px 0',
    '&:hover': {
      textDecoration: `underline ${themeConWeb.color.dangerLight}`,
    },
  },
}))

const MyAccounts = ({ isLoadingOffices }) => {
  const userTeam = useSelector(selectUserTeam)
  const offices = useSelector(selectOfficeAccounts)
  const isPreferredLocation = useSelector(selectLocationPreferred)
  const classes = useStyles()
  const isTeamManager = userTeam => userTeam?.team?.manager
  const isOfficeManager = office => office.isManager
  const isStandardOffice = office => office.preferredType === 'STANDARD'

  const formatTeamPath = accountId => {
    return formatUrl(teamAccountRoute.path, {
      accountId: `${accountId}`,
    })
  }

  const userTeamPath = () => {
    return formatTeamPath(userTeam?.team?.accountId)
  }

  if (isLoadingOffices) {
    return (
      <>
        <Box marginY={3}>
          <Skeleton variant="rect" width="100%" height="42px" />
        </Box>
        <Skeleton variant="rect" width="100%" height="400px" />
      </>
    )
  }
  return (
    <>
      <Box paddingRight={4}>
        {isPreferredLocation && !hasTeam(userTeam) ? (
          <>
            {offices.map(office => (
              <>
                <OfficeWidget
                  key={office.id}
                  name={office.name}
                  classes={classes}
                  showManageLink={!isStandardOffice(office) && isOfficeManager(office)}
                  manageLink={formatTeamPath(office.id)}
                />
                {isStandardOffice(office) ? (
                  <Box width={240}>
                    <Box marginY={3}>
                      <Divider />
                    </Box>
                    <HomeUnlockPreferredPricing officeId={office.id} />
                  </Box>
                ) : null}
              </>
            ))}
          </>
        ) : null}

        {!isEmpty(userTeam.team) && (
          <>
            <TeamWidget
              name={userTeam.team.name}
              classes={classes}
              manageLink={userTeamPath()}
              showManageLink={isTeamManager(userTeam)}
              members={userTeam.team.membersPreview}
            />
          </>
        )}
      </Box>
    </>
  )
}
const mapStateToProps = state => {
  return {
    isLoadingOffices: state.isLoadingOffices,
  }
}

export default connect(mapStateToProps)(MyAccounts)
